var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("csp-form-group-select-searchable", {
    attrs: {
      form: _vm.insurancePolicyForm,
      options: _vm.options,
      property: _vm.property,
      required: _vm.required,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }